import { ErpMetadataSchema, ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const ContractProductOverviewSchema = oz.object({
  id: ObjectIdSchema,
  name: oz.string(),
  description: oz.string(),
  totalPrice: oz.number(),
  erpMetadata: ErpMetadataSchema.optional(),
}).openapi('ContractProductOverview');

export type ContractProductOverview = oz.infer<typeof ContractProductOverviewSchema>;